import type { ReactNode } from 'react'

import './portal-empty-state.css'

export interface PortalEmptyStateProps {
    /** Emoji or icon to display */
    icon: ReactNode
    /** Message text */
    message: string
    /** Optional CSS class */
    className?: string
}

export const PortalEmptyState = ({ icon, message, className = '' }: PortalEmptyStateProps) => (
    <div className={`portal-empty-state ${className}`}>
        <div className="portal-empty-state__icon">{icon}</div>
        <div className="portal-empty-state__text">{message}</div>
    </div>
)
